import React, { use } from 'react';

import { buttonProps } from 'src/components/layout/redesign/career-header-desktop/career-header-helper';
import HeaderDesktop from 'src/components/layout/redesign/header-desktop';
import { CareerCmsContent } from 'src/content/career-content';
import { SiteContext } from 'src/context/site-context';

const CareerHeaderDesktop = () => {
  const { buildType, language } = use(SiteContext);
  const { careerHeaderContent } = use(CareerCmsContent);

  return (
    <HeaderDesktop
      headerContent={careerHeaderContent.careerHeader}
      primaryButton={buttonProps(
        careerHeaderContent?.careerHeader.headerButtonPrimary,
        buildType,
        'Primary Button - Navigation',
        'Career Desktop Header',
        language
      )}
      secondaryButton={buttonProps(
        careerHeaderContent?.careerHeader.headerButtonSecondary,
        buildType,
        '"Secondary Button" - Navigation',
        'CCareer Desktop Header',
        language
      )}
    />
  );
};

export default CareerHeaderDesktop;
